import classNames from "classnames";
import React, { ReactElement } from "react";
import { AppCard, AppCardProps } from "./AppCard";
import { IsDefined } from "./IsDefined";

interface Props extends AppCardProps {
  title?: string;
}

export function InfoCard(props: Props): ReactElement {
  const { title, className, children, ...rest } = props;
  return (
    <AppCard {...rest} className={classNames(className, "InfoCard")}>
      <IsDefined value={title}>{(definedTitle) => <div>{definedTitle}</div>}</IsDefined>
      <IsDefined value={children}>
        {(definedChildren) => <div className="__children">{definedChildren}</div>}
      </IsDefined>
    </AppCard>
  );
}
